export class BuildError extends Error {
  errorMessage: string

  constructor(errorMessage: string) {
    super(errorMessage)
  }
}
